import { useUserStore } from "@/stores/user";
import type { MiddlewareContext } from "@/types";

export const impersonateTarget = ({ next, router }: MiddlewareContext) => {
  const store = useUserStore();
  const impersonateTarget = localStorage.getItem("IMPERSONATE_TARGET");

  /* 
  If we get have an IMPERSONATE_TARGET value and an impersonator_id in the current user, 
  it means we just impersonated a user and want to redirect to another page.
  */
  if (store.currentUser?.impersonator_id && impersonateTarget) {
    localStorage.removeItem("IMPERSONATE_TARGET");
    router.push(impersonateTarget);
    return;
  }

  return next();
};
